import { http } from "api/apiConfig";
import { ACTIVATE_AGREEMENT_DETAIL, ACTIVATE_PRODUCT, AGREEMENT_PRICE, AGREEMENTS, AVAILABLE_PRODUCTS, CHANGE_PRODUCT, CUSTOMER_AGREEMENT_PRODUCT_PRICES_URL, LINK_PRODUCT, POST_PRODUCT, PRODUCTS_INSTALLER, PRODUCTS_TECHNICIAN, REMOVE_PRODUCT, } from "constants/endpoints";
export const fetchCustomerProductsTechnician = async (customerId) => {
    const url = PRODUCTS_TECHNICIAN(customerId);
    const { data } = await http.get(url);
    return data;
};
export const fetchCustomerProductsInstaller = async (customerId) => {
    const url = PRODUCTS_INSTALLER(customerId);
    const { data } = await http.get(url);
    return data;
};
export const addCustomerProduct = async ({ agreementId, customerId, product, }) => {
    const url = POST_PRODUCT(agreementId);
    const body = {
        agreementId,
        customerId,
        productIds: [product.value],
    };
    const { data } = await http.post(url, body);
    return data;
};
export const activateProductWithSerials = async ({ productId, body }) => {
    const url = ACTIVATE_PRODUCT(productId);
    const { data } = await http.put(url, body);
    return data;
};
export const activateNoBody = async (productId) => {
    const url = ACTIVATE_AGREEMENT_DETAIL(productId);
    const { data } = await http.put(url);
    return data;
};
export const deleteCustomerProduct = async (agreementDetailId) => {
    const url = REMOVE_PRODUCT(agreementDetailId);
    const { data } = await http.delete(url);
    return data;
};
export const changeProductSerial = async (dpadId, serialNumber) => {
    const url = CHANGE_PRODUCT(dpadId, serialNumber);
    const { data } = await http.put(url);
    return data;
};
export const fetchAgreements = async (customerId) => {
    const url = AGREEMENTS(customerId);
    const { data } = await http.get(url);
    return data;
};
export const fetchAgreementPrices = async (customerId) => {
    const url = AGREEMENT_PRICE(customerId);
    const { data } = await http.get(url);
    return data;
};
export const fetchAgreementWithPrices = async (customerId) => {
    const url = CUSTOMER_AGREEMENT_PRODUCT_PRICES_URL(customerId);
    const { data } = await http.get(url);
    return data;
};
export const fetchAvailableProducts = async (agreementId) => {
    const url = AVAILABLE_PRODUCTS(agreementId);
    const { data } = await http.get(url);
    return data;
};
export const linkSingleProduct = async (customerId, productId, dpadId) => {
    const url = LINK_PRODUCT(customerId, productId);
    const { data } = await http.put(url, [dpadId]);
    return data;
};
export const linkProduct = async (customerId, productId, dpadIdsToLink) => {
    const url = LINK_PRODUCT(customerId, productId);
    const { data } = await http.put(url, dpadIdsToLink);
    return data;
};
